import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionBudgetGoal' })
    .attrs({
        direction: 'row',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
    })``;
